import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
    selector: '[insideViewport]',
    standalone: false
})
export class InsideViewportDirective {

  @Output() insideViewport = new EventEmitter();

  constructor(
    private readonly elementRef: ElementRef
  ) {  }

  insideView(){
    const windowHeight = window.innerHeight;
    const boundedRect = this.elementRef.nativeElement.getBoundingClientRect();

    if (boundedRect.top >= 0 && boundedRect.bottom <= windowHeight) {
      this.insideViewport.emit(true);
    } else {
      this.insideViewport.emit(false);
    }
  }


  @HostListener('document:mousewheel', ['$event'])
  public onScrollBy(): any {
    this.insideView();
  }

  @HostListener('keydown.tab', ['$event'])
  public onKeyTab(): any {
    this.insideView();
  }
  
  @HostListener('keydown.shift.tab', ['$event'])
  public onKeyShiftTab(): any {
    this.insideView();
  }
  
  @HostListener('document:keyup', ['$event'])
  public onKeyArrowDown(evento: KeyboardEvent): any { 
    if (evento.key === 'ArrowDown' || evento.key === 'ArrowUp' ) this.insideView();
  }

}